import { errorLogService } from "../services/errorLogService";

export function logErrorToServer(error, context = {}) {
  const payload = {
    timestamp: new Date().toISOString(),
    level: "ERROR",
    logger: context.logger || "frontend",
    message: error?.message || error?.toString() || String(error),
    exceptionClass: error?.constructor?.name || "Error",
    stackTrace: error?.stack || null,
    requestUri: context.requestUri || null,
    requestMethod: context.requestMethod || null,
    userId: context.userId || null,
    tenantId: context.tenantId || null,
    correlationId: context.correlationId || null,
    ipAddress: null,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
  };

  // Also log to browser console
  console.error(`[${context.logger || "frontend"}] ${payload.message}`, payload.stackTrace ? "\n" + payload.stackTrace : "");

  // Send to backend (fire-and-forget, don't block UI)
  errorLogService.logError(payload).catch(() => {
    // Ignore failures to send error logs to avoid infinite loops
  });
}

export function wrapAsync(fn, context = {}) {
  return async (...args) => {
    try {
      return await fn(...args);
    } catch (error) {
      logErrorToServer(error, context);
      throw error;
    }
  };
}
